module.exports = __webpack_public_path__ + "afa5d5300a1b865c6902541f4657ee86.png";